/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import Rails from '@rails/ujs';
import Turbolinks from "turbolinks";
import 'bootstrap/dist/js/bootstrap';
import 'admin-lte/dist/js/adminlte';
import 'admin-lte/plugins/iCheck/icheck';
import 'admin-lte/bower_components/select2/dist/js/select2.min.js';
import 'moment/locale/ja';
import 'bootstrap-daterangepicker';
import 'floatthead';
import 'print-js/dist/print';
import { registerTopPageModeBootstrap } from '../shared/top_page_mode';
import { registerSidebarDrawerBootstrap } from '../shared/sidebar_drawer';

Rails.start();
Turbolinks.start();
registerTopPageModeBootstrap();
registerSidebarDrawerBootstrap();

import '../pages/menu';
import '../pages/main';
import '../pages/companies';
import '../pages/manuals';
import '../pages/notifies';
import '../pages/register';
import '../pages/search';
import '../pages/search_delivery_note';
import '../pages/search_invoice';
import '../pages/search_milsheet';
import '../pages/user_data';
import '../pages/user_data_histories';
import '../pages/user_data_items';
import '../pages/users';
import '../pages/search/display';
import '../pages/search_delivery_note/display';
import '../pages/search_invoice/display';
import '../pages/event_logs';
import '../pages/stocks';
import '../pages/internal_stocks';
import '../pages/steel_pipes';
import '../pages/unit_weights';
import '../pages/stock_thresholds';
import '../pages/warehouses';
import '../pages/maintenance_schedules';
import '../pages/milsheet_company_masters';
import '../pages/quotation_order_select_item';
import '../pages/quotation_orders';
import '../pages/quotation_order_histories';
import '../pages/delivery_destinations';
import '../pages/department_selections';
import '../pages/steel_pipe_item_names';
import '../pages/busho_selection';
import '../pages/sub_setting_form';
